import { render, staticRenderFns } from "./CurationFilterDefaultLayout.vue?vue&type=template&id=77507854&scoped=true"
import script from "./CurationFilterDefaultLayout.vue?vue&type=script&lang=js"
export * from "./CurationFilterDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77507854",
  null
  
)

export default component.exports